export const GRAPH_TABS = [
  { key: "correctness", label: "CORRECTNESS RATE" },
  { key: "accuracyandprecision", label: "ACCURACY AND PRECISION" },
  { key: "precision", label: "PRECISION" },
  { key: "level", label: "LEVEL" },
  { key: "activity", label: "ACTIVITY CHART" },
];

export let DISORDERS_LIST = {
  "EyeMovementDisorders": [
    "Saccadic dysfunction",
    "Pursuit dysfunction",
    "Fixation instability",
    "Nystagmus",
    "Poor visual tracking",
    "Oculomotor apraxia"
  ],
  "EyeCoordinationDisorders": [
    "Convergence insufficiency",
    "Convergence excess",
    "Divergence insufficiency",
    "Divergence excess",
    "Strabismus",
    "Intermittent exotropia",
    "Esotropia",
    "Exotropia",
    "Hypertropia",
    "Phorias"
  ],
  "FocusingDisorders": [
    "Accommodative insufficiency",
    "Accommodative excess",
    "Accommodative infacility",
    "Presbyopia",
    "Lag of accommodation",
    "Lead of accommodation"
  ],
  "VisualProcessingDisorders": [
    "Visual discrimination problems",
    "Visual memory dysfunction",
    "Visual spatial relations issues",
    "Visual-motor integration issues",
    "Visual closure problems",
    "Figure-ground perception issues",
    "Form constancy issues",
    "Visual sequential memory problems",
    "Visual attention deficit"
  ],
  "ReadingAndLearningProblems": [
    "Reading fluency problems",
    "Skipping lines while reading",
    "Reversal of letters and numbers",
    "Difficulty copying from board",
    "Visual perceptual delay",
    "Double vision during reading"
  ],
  "NeurologicalOrDevelopmentalConditions": [
    "Amblyopia",
    "Traumatic brain injury (TBI)-related vision issues",
    "Cerebral visual impairment",
    "Post-concussion vision syndrome",
    "Autism-related visual processing issues",
    "ADHD-related visual attention problems",
    "Dyslexia"
  ],
  "OtherConditionsOrSymptoms": [
    "Eye strain",
    "Photophobia",
    "Motion sensitivity",
    "Visual fatigue",
    "Blurred vision not due to refraction",
    "Difficulty with 3D vision"
  ]
}

